import { IValidator, IPackageBuyInfo } from '@/Interfaces';

export class PackageBuyInfoValidator implements IValidator<IPackageBuyInfo> {
  public isValid(value: IPackageBuyInfo): Record<string, string> {
    const validations: Record<string, string> = {};
    if (!value.bidDueDate) validations.bidDueDate = 'Bid Due is required';
    if (!value.bidRequestDate) validations.bidRequestDate = 'Bid Request is required';
    if (value.bidPrice !== undefined && value.bidPrice !== null && (value.bidPrice < 0 || value.bidPrice > 9999.9999)) validations.bidPrice = 'Bid Price must be between 0 and 9999.9999';
    if (value.buyPrice !== undefined && value.buyPrice !== null && (value.buyPrice < 0 || value.buyPrice > 9999.9999)) validations.buyPrice = 'Buy Price must be between 0 and 9999.9999';
    if (!value.channelTypeId) validations.channelTypeId = 'Channel is required';
    if (!value.buyer?.id) validations.buyerId = 'Buyer is required';
    if (!value.seller?.id) validations.sellerId = 'Seller is required';
    if (!value.includeLoanRights && !value.includePPPRights && !value.includeServicingRights) validations.stripType = 'Strip Type is required';

    if (value.bidRequestDate && value.bidDueDate && new Date(value.bidRequestDate) > new Date(value.bidDueDate)) {
      validations.packageBuyInfo = validations.bidRequestDate = 'Bid Request Date cannot be after Bid Due Date.';
      validations.packageBuyInfo = validations.bidDueDate = 'Bid Due Date cannot be before Bid Request Date.';
    }

    // Check if the settled date is after the trade date
    if (value.settledDate && value.tradeDate) {
      const tradeDate = new Date(value.tradeDate);
      const settledDate = new Date(value.settledDate);
      if (settledDate < tradeDate) {
        validations.settledDate = 'Funding Settlement Date cannot be before Trade Date';
      }
    }

    // Check if the settled date is a weekend
    if (value.settledDate) {
      const settledDate = new Date(value.settledDate);
      const isWeekend = settledDate.getDay() === 0 || settledDate.getDay() === 6; // 0 = Sunday, 6 = Saturday
      if (isWeekend) {
        validations.settledDate = 'Funding Settlement date must be a business day';
      }
    }

    return validations;
  }
}